import { TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { MobileController } from '../../controllers/mobile-controller';
/**
 * The SeSearchForm component
 * @element se-search-form
 */
@customElement('se-search-form')
export class SeSearchForm extends OutlineElement {
  mobileController = new MobileController(this);

  /**
   * Exposes full component to light-DOM
   */
  protected createRenderRoot() {
    return this;
  }

  @property({ type: Boolean })
  hasSelect = false;

  @property({ type: Boolean })
  isMobile: boolean;

  /**
   * The place holder text of the slotted search form input. Set by this.setPlaceholder().
   */
  @property({ type: String })
  placeholder: string;

  /**
   * Ref to the search text input.
   */
  textInput: HTMLInputElement;

  render(): TemplateResult {
    return html``;
  }

  firstUpdated() {
    this.setSelect();
  }

  updated() {
    this.isMobile = this.mobileController.isMobile;
    this.setPlaceholder();
    this.togglePlaceHolder();
  }

  /**
   * Recursively checks the wrapped markup for the select element and .form-autocomplete.
   * If found, updates the hasSelect prop and passes the has-select class to the autocomplete form.
   */
  setSelect() {
    const form = [...this.children].filter(
      child => child.nodeName === 'FORM'
    )[0] as HTMLElement;

    const recur = (el: HTMLElement) => {
      if (el.children.length > 0) {
        [...el.children].forEach(child => {
          if (child.nodeName === 'SELECT') {
            this.hasSelect = true;
            form.classList.add('has-select');
          }
          if (child.classList.contains('form-autocomplete')) {
            this.textInput = child as HTMLInputElement;

            if (this.hasSelect) {
              child.classList.add('has-select');
            }
          }
          if (child.nodeName !== 'SELECT' && child.children.length > 0) {
            recur(child as HTMLElement);
          }
        });
      }
    };

    if (form) {
      recur(form);
    }
  }

  /**
   * Sets the place holder
   */
  setPlaceholder() {
    if (!this.placeholder) {
      this.placeholder = this.textInput?.placeholder;
    }
  }

  /**
   * Toggels the placeholder text at mobile.
   */
  togglePlaceHolder() {
    if (this.isMobile && this.placeholder && this.textInput) {
      this.textInput.placeholder = 'Search';
    }
    if (!this.isMobile && this.placeholder && this.textInput) {
      this.textInput.placeholder = this.placeholder;
    }
  }
}
